import React, { ReactNode, useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import { SliderContainer } from './slideCarousel.styled';

interface SlideCarouselProps<T> {
  slideConfig: T[];
  slideComponent: ReactNode;
}

// const settings = {
//   dots: true,
//   centerMode: true,
//   className: 'center',
//   infinite: true,
//   slidesToShow: 1,
//   // slidesToScroll: 2,
//   swipe: true,
//   swipeToSlide: true, // allows free-swipe (not locked to full slide)
//   draggable: true, // allows mouse drag as well
//   touchThreshold: 10,
//   centerPadding: '250px',

//   responsive: [
//     {
//       breakpoint: 1280,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         dots: true,
//         centerPadding: '250px',
//       },
//     },
//     // {
//     //   breakpoint: 1024,
//     //   settings: {
//     //     slidesToShow: 1,
//     //     slidesToScroll: 1,
//     //     dots: true,
//     //     centerPadding: '50px',
//     //   },
//     // },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         centerPadding: '0px',
//         centerMode: false,
//       },
//     },
//   ],
// };

export function SlideCarousel<T>({ slideConfig, slideComponent: SlideComponent }: SlideCarouselProps<T>) {
  const settings = {
    dots: true,
    centerMode: true,
    className: 'center',
    infinite: slideConfig.length > 1 ? true : false,
    slidesToShow: 1,

    swipe: true,
    swipeToSlide: true,
    draggable: true,
    touchThreshold: 10,
    centerPadding: '250px', // default for >= 1280px

    responsive: [
      {
        breakpoint: 1280,
        settings: {
          centerPadding: '50px', // < 1280
        },
      },
      {
        breakpoint: 600,
        settings: {
          centerMode: false, // < 600
          centerPadding: '0px',
        },
      },
    ],
  };

  return (
    <SliderContainer className="slider-container">
      <Slider {...settings}>
        {slideConfig.map((slide) => (
          <SlideComponent key={slide.id} {...slide} />
        ))}
      </Slider>
    </SliderContainer>
  );
}
